<template>
  <el-row>
    <el-col :span="5">
      <basic-container>
        <div style="display: flex">
          <!-- <span>项目名称:</span> -->
          <el-form inline>
            <el-form-item label="项目名称">
              <el-select
                v-model="form.projectId"
                placeholder="请选择项目"
                @change="changeSelectProject"
              >
                <el-option
                  v-for="(item, index) in projectIdList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <avue-tree
          :option="treeOption"
          :data="treeData"
          @node-click="nodeClick"
          @update="treeUpdate"
          @save="saveNode"
          @del="delNode"
          v-model="treeForm"
        />
      </basic-container>
    </el-col>
    <el-col :span="19">
      <basic-container>
        <avue-crud
          :option="option"
          :data="data"
          :page.sync="page"
          :permission="permissionList"
          :before-open="beforeKnowledgeOpen"
          v-model="form"
          ref="crud"
          @row-del="rowKnowledgeDel"
          @search-change="searchKnowledgeChange"
          @search-reset="searchKnowledgeReset"
          @selection-change="selectionKnowledgeChange"
          @current-change="currentKnowledgeChange"
          @size-change="sizeKnowledgeChange"
          @refresh-change="onKnowledgeLoad"
          @on-load="onKnowledgeLoad"
        >
          <template slot="menuLeft">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-plus"
              v-if="permission.knowledge_add"
              @click="addKnowledgeOpen"
              >新 增
            </el-button>
            <el-button
              type="primary"
              size="small"
              icon="el-icon-service"
              v-if="permission.knowledge_check"
              @click="handleKnowledgeCheck()"
              >审 核
            </el-button>
          </template>
          <!--自定义查看按钮-->
          <template slot-scope="{ row }" slot="menu">
            <el-button
              type="text"
              icon="el-icon-view"
              size="small"
              plain
              style="border: 0; background-color: transparent !important"
              @click.stop="viewClick(row)"
              >查看
            </el-button>
            <el-button
              type="text"
              icon="el-icon-delete"
              size="small"
              plain
              style="border: 0; background-color: transparent !important"
              @click.stop="rowKnowledgeDel(row)"
              >删除
            </el-button>
          </template>
        </avue-crud>

        <el-dialog
          title="新增知识内容"
          v-if="addDialogFormVisible"
          :visible.sync="addDialogFormVisible"
          append-to-body
        >
          <el-form :model="addForm" ref="addForm" :rules="rules">
            <el-form-item
              label="目录名称"
              prop="parentMenuName"
              :label-width="formLabelWidth"
            >
              <el-input v-model="addForm.parentMenuName" readonly></el-input>
              <el-input v-model="addForm.parentId" v-show="false"></el-input>
            </el-form-item>

            <el-form-item
              label="标题"
              prop="knowledgeTitle"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model="addForm.knowledgeTitle"
                maxlength="100"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="知识类型"
              prop="knowledgeType"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model="addForm.knowledgeType"
                maxlength="100"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="查看权限"
              prop="menuPermission"
              :label-width="formLabelWidth"
            >
              <el-select
                v-model="addForm.menuPermission"
                style="width: 100%"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in addForm.menuPermissions"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="文件上传" :label-width="formLabelWidth">
              <el-upload
                class="upload-demo"
                action="/api/v4ward/oss/customEndpoint/put-file"
                :headers="headers"
                :on-remove="fileHandleRemove"
                :on-error="fileHandleError"
                :file-list="this.fileList"
                :on-success="fileUploadSuccess"
                multiple
              >
                <el-button size="small" type="primary" icon="el-icon-upload"
                  >点击上传</el-button
                >
                <div class="el-upload__tip" slot="tip">
                  只能上传文件不超过256M
                </div>
              </el-upload>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancleAddForm">取 消</el-button>
            <el-button type="submit" @click="handleKnowledgeAdd('addForm')"
              >确 定</el-button
            >
          </div>
        </el-dialog>

        <el-dialog
          title="查看知识内容"
          v-if="viewDialogFormVisible"
          :visible.sync="viewDialogFormVisible"
          append-to-body
        >
          <el-row>
            <el-form :model="viewForm">
              <el-form-item
                label="目录名称"
                prop="parentMenuName"
                :label-width="formLabelWidth"
              >
                <el-input v-model="viewForm.parentMenuName" readonly></el-input>
              </el-form-item>

              <el-form-item
                label="标题"
                prop="knowledgeTitle"
                :label-width="formLabelWidth"
              >
                <el-input v-model="viewForm.knowledgeTitle" readonly></el-input>
              </el-form-item>
              <el-form-item
                label="知识类型"
                prop="knowledgeType"
                :label-width="formLabelWidth"
              >
                <el-input v-model="viewForm.knowledgeType" readonly></el-input>
              </el-form-item>
              <el-form-item
                label="查看权限"
                prop="menuPermission"
                :label-width="formLabelWidth"
              >
                <el-input v-model="viewForm.menuPermission" readonly></el-input>
              </el-form-item>
              <el-form-item label="文件上传" :label-width="formLabelWidth">
              </el-form-item>
            </el-form>
          </el-row>
          <el-row>
            <el-col :offset="4">
              <el-table
                v-if="viewDialogFormVisible"
                :data="fileTableData"
                border
                style="width: 70.4%"
              >
                <el-table-column prop="originalName" label="文件名" width="500">
                </el-table-column>
                <el-table-column label="操作" width="143">
                  <template slot-scope="scope">
                    <el-button
                      @click="fileDownloadClick(scope.row)"
                      type="text"
                      size="small"
                      >下载</el-button
                    >
                    <el-button
                      @click="fileViewClick(scope.row)"
                      type="text"
                      size="small"
                      >文件预览</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
          <div slot="footer" class="dialog-footer">
            <el-button @click="viewDialogFormVisible = false">关 闭</el-button>
          </div>
        </el-dialog>

        <el-dialog
          title="审核拒绝"
          :visible.sync="checkDialogFormVisible"
          append-to-body
          width="30%"
        >
          <el-form :model="checkForm" class="demo-form-inline">
            <el-form-item label="拒绝原因" prop="knowledgeRemark">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入拒绝原因"
                v-model="checkForm.knowledgeRemark"
              >
              </el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="checkDialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="handleKnowledgeReject"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </basic-container>
    </el-col>
  </el-row>
</template>

<script>
import { getDictionary } from "@/api/system/dict";
import { getListByIds } from "@/api/resource/attach";
import { downloadFile } from "@/api/resource/oss";
import { getProjectList } from "@/api/crmedical/project/project";
import { Base64 } from 'js-base64';
import settings from '@/config/vd-settings';
import urlSettings from '@/config/url-settings';
import { getToken } from '@/util/auth';
import {
  getMenuTree,
  getMenuLazyTree,
  addMenu,
  removeMenu,
  updateMenu,
  getKnowledgeList,
  getKnowledgeDetail,
  removeKnowledge,
  addKnowledge,
  checkOk,
  checkReject,
} from "@/api/crmedical/knowledge/knowledge";
import { mapGetters } from "vuex";

export default {
  data() {
    let form = {};
    return {
      rules: {
        knowledgeTitle: [
          { required: true, message: "请输入标题" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符" },
        ],
        knowledgeType: [
          { required: true, message: "请输入类型" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符" },
        ],
        menuPermission: [{ required: true, message: "请选择权限" }],
      },
      attachIds: [],
      fileList: {},
      addDialogFormVisible: false,
      viewDialogFormVisible: false,
      checkDialogFormVisible: false,
      formLabelWidth: "120px",
      initTreeFlag: true,
      treeForm: {},
      form: form,
      addForm: {},
      viewForm: {},
      checkForm: {},
      fileTableData: {},
      query: {},
      loading: true,
      projectIdList: [], //项目下拉框
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },

      treeDeptId: "",
      treeDeptName: "",
      treeData: [],
      treeOption: {
        nodeKey: "id",
        addBtn: true,
        editBtn: true,
        delBtn: true,
        menu: true,
        lazy: true,
        treeLoad: function (node, resolve) {
          if (node.data.length != 0) {
            getMenuLazyTree(form.projectId, node.data.id).then((res) => {
              resolve(res.data);
            });
          }
        },
        formOption: {
          column: [
            {
              label: "权限",
              prop: "menuPermission",
              type: "select",
              dicUrl: "/api/blade-system/dict/dictionary?code=data_scope_type",
              props: {
                label: "dictValue",
                value: "dictKey",
              },
              dataType: "number",
              rules: [
                {
                  required: true,
                  message: "请输入节点权限",
                  trigger: "change",
                },
              ],
            },
          ],
        },
        props: {
          labelText: "目录名称",
          overHidden: true,
          label: "title",
          value: "value",
          children: "children",
        },
      },

      //知识内容
      selectionList: [],
      option: {
        height: "auto",
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        selection: true,
        dialogClickModal: false,
        column: [
          {
            label: "编号",
            prop: "knowledgeNo",
            addDisplay: false,
            overHidden: true,
            rules: [
              {
                required: false,
                message: "请输入编号",
                trigger: "change",
              },
            ],
          },
          {
            label: "标题",
            prop: "knowledgeTitle",
            overHidden: true,
            rules: [
              {
                required: false,
                message: "请输入标题",
                trigger: "change",
              },
            ],
          },
          {
            label: "类型",
            prop: "knowledgeType",
            overHidden: true,
            rules: [
              {
                required: false,
                message: "请输入类型",
                trigger: "change",
              },
            ],
          },
          // {
          //   label: "备注",
          //   prop: "knowledgeRemark",
          //   rules: [{
          //     required: false,
          //     message: "请输入备注",
          //     trigger: "change"
          //   }]
          // },
          {
            label: "状态",
            prop: "knowledgeStatus",
            type: "select",
            dicUrl: "/api/blade-system/dict/dictionary?code=knowledge_status",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "number",
            rules: [
              {
                required: false,
                message: "请输入状态",
                trigger: "change",
              },
            ],
          },
        ],
      },
      data: [],
      headers:{},
    };
  },

  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.knowledge_add, false),
        viewBtn: this.vaildData(this.permission.knowledge_view, false),
        delBtn: this.vaildData(this.permission.knowledge_delete, false),
        editBtn: this.vaildData(this.permission.knowledge_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  created() {
    console.log("urlSettings=========>",urlSettings);
    this.headers['Authorization'] = `Basic ${Base64.encode(
      `${settings.clientId}:${settings.clientSecret}`
    )}`;
    // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
    this.headers['Blade-Auth'] = 'bearer ' + getToken();
    getProjectList().then((res) => {
      console.log(res.data);
      this.projectIdList = res.data;
      this.form.projectId = this.projectIdList[0].id;
      this.initData(this.projectIdList[0].id);
      this.query = { projectId: this.form.projectId };
      // this.onLoad();
    });
  },
  methods: {
    changeSelectProject(val) {
      this.form.projectId = val;
      this.treeDeptId = "";
      this.initData(val);
    },
    //树形菜单目录
    initData(projectId) {
      console.log(projectId);
      getMenuTree(projectId).then((res) => {
        this.treeData = res.data;
      });
    },
    saveNode(data, parent, done, loading) {
      if (parent.title.length > 50) {
        this.$message.warning("目录名称超出50字符长度!");
        this.initData(this.form.projectId);
        done();
        return;
      }
      this.treeForm.projectId = this.form.projectId;
      this.treeForm.menuName = parent.title;
      this.treeForm.menuPermission = parent.menuPermission;
      if (data.id) {
        this.treeForm.parentId = data.id;
      }
      if (data.title) {
        this.treeForm.parentMenuName = data.title;
      }
      addMenu(this.treeForm).then(
        () => {
          this.initData(this.form.projectId);
          this.$message.success("操作成功!");
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
      this.treeForm = {};
    },
    treeUpdate(data, parent, done, loading) {
      if (parent.title.length > 50) {
        this.$message.warning("目录名称超出50字符长度!");
        done();
        return;
      }
      this.treeForm.projectId = this.form.projectId;
      this.treeForm.menuName = parent.title;
      this.treeForm.menuPermission = parent.menuPermission;
      this.treeForm.id = data.id;
      updateMenu(this.treeForm).then(
        () => {
          this.initData(this.form.projectId);
          this.$message.success("操作成功!");
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
      this.treeForm = {};
    },
    delNode(data, done) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (data.hasChildren) {
            this.$message.error("请删除节点以下的目录或文件!");
          } else {
            return removeMenu({ id: data.id }).then(() => {
              this.$message.success("操作成功!");
            });
          }
        })
        .then(() => {
          this.initData(this.form.projectId);
          this.treeForm = {};
          done();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    nodeClick(data) {
      this.treeDeptId = data.value;
      this.treeDeptName = data.title;

      this.query.parentId = this.treeDeptId;
      this.query.projectId = this.form.projectId;
      this.onKnowledgeLoad();
    },

    //知识内容
    beforeKnowledgeOpen(done, type) {
      if ("add" == type) {
        if ("" === this.treeDeptId || null === this.treeDeptId) {
          this.$message.warning("请选择要添加的文件目录");
          return;
        }
      }
      if (["edit", "view"].includes(type)) {
        getKnowledgeDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchKnowledgeReset() {
      this.query = {};
      this.query.projectId = this.form.projectId;
      this.query.parentId = this.treeDeptId;
      this.onKnowledgeLoad();
    },
    searchKnowledgeChange(params, done) {
      this.query = params;
      this.query.projectId = this.form.projectId;
      this.query.parentId = this.treeDeptId;
      this.page.currentPage = 1;
      this.onKnowledgeLoad();
      done();
    },
    selectionKnowledgeChange(list) {
      this.selectionList = list;
    },
    selectionKnowledgeClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentKnowledgeChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeKnowledgeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    addKnowledgeOpen() {
      if ("" === this.treeDeptId || null === this.treeDeptId) {
        this.$message.warning("请在左侧选择要添加的文件目录！");
        return;
      }
      let self = this;
      //获取数据字典
      getDictionary({ code: "data_scope_type" }).then(({ data }) => {
        self.addForm.parentMenuName = this.treeDeptName;
        self.addForm.parentId = this.treeDeptId;
        self.addForm.menuPermissions = data.data;
        self.addForm.projectId = this.form.projectId;
        self.addDialogFormVisible = true;
      });
    },

    fileHandleRemove(file, fileList) {
      let delAttachId = file.response.data.attachId;
      let index = this.attachIds.indexOf(delAttachId);
      this.attachIds.splice(index, 1);
    },
    fileHandleError(err, file, fileList) {
      this.$message.warning("上传文件不能超过256M！");
      return;
    },
    fileUploadSuccess(response, file, fileList) {
      this.attachIds.push(response.data.id);
    },
    handleKnowledgeAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addForm.knowledgeAttachIds = this.attachIds.toString();
          addKnowledge(this.addForm).then(
            () => {
              this.onKnowledgeLoad();
              this.$message.success("操作成功!");
              this.attachIds = [];
              this.cancleAddForm();
            },
            (error) => {
              this.attachIds = [];
              window.console.log(error);
            }
          );
        } else {
          this.attachIds = [];
          console.log("请填写表单内容！");
          return false;
        }
      });
    },
    handleKnowledgeCheck() {
      if (this.selectionList.length === 0 || this.selectionList.length > 1) {
        this.$message.warning("请选择一条知识内容进行审核");
        return;
      }
      if (
        this.selectionList[0].knowledgeStatus == 3 ||
        this.selectionList[0].knowledgeStatus == 4
      ) {
        this.$message.warning("记录无需再审核！");
        return;
      }
      this.$confirm("是否审核通过?", {
        confirmButtonText: "通过",
        cancelButtonText: "拒绝",
        type: "warning",
        distinguishCancelAndClose: true,
      })
        .then(() => {
          this.checkForm.id = this.selectionList[0].id;
          checkOk(this.checkForm).then(() => {
            this.onKnowledgeLoad();
            this.$message.success("操作成功!");
            this.$refs.crud.toggleSelection();
          });
        })
        .catch((e) => {
          if ("close" != e) {
            this.checkDialogFormVisible = true;
          }
        });
    },
    handleKnowledgeReject() {
      this.checkForm.id = this.selectionList[0].id;
      checkReject(this.checkForm).then(() => {
        this.onKnowledgeLoad();
        this.checkDialogFormVisible = false;
        this.$message.success("操作成功!");
        this.$refs.crud.toggleSelection();
      });
    },
    rowKnowledgeDel(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return removeKnowledge({ id: row.id });
        })
        .then(() => {
          this.onKnowledgeLoad();
          this.$message.success("操作成功!");
        });
    },

    viewClick(row) {
      let temRow = this.deepClone(row);
      this.viewForm = this.deepClone(row);
      let self = this;
      self.fileTableData = "";
      //获取数据字典
      getDictionary({ code: "data_scope_type" })
        .then(({ data }) => {
          for (let i = 0; i < data.data.length; i++) {
            let tempPermission = data.data[i];
            if (temRow.menuPermission.toString() === tempPermission.dictKey) {
              self.viewForm.menuPermission = tempPermission.dictValue;
              break;
            }
          }
          self.viewDialogFormVisible = true;
        })
        .then(() => {
          getListByIds({ ids: temRow.knowledgeAttachIds }).then((res) => {
            self.fileTableData = res.data.data;
            self.loading = false;
          });
        });
    },
    fileDownloadClick(row) {
      downloadFile(row.link, row.originalName);
    },
    fileViewClick(row) {
      console.log(urlSettings);
      window.open(

        // process.env.VUE_APP_FILE_VIEW_URL + encodeURIComponent(row.localLink)
        urlSettings.FILE_VIEW_URL + encodeURIComponent(Base64.encode(row.link))
      );
    },
    cancleAddForm() {
      this.addDialogFormVisible = false;
      this.addForm = {};
    },
    onKnowledgeLoad(page) {

        page = page || this.page;
        this.loading = true;
        console.log(this.query);
        if(this.query.parentId) {

          getKnowledgeList(
            Object.assign(
              { current: page.currentPage, size: page.pageSize },
              this.query
            )
          ).then(({ data }) => {
            if (this.firstDisplayFlag) {
              let ent = document.querySelector("input[placeholder=请选择项目]");
              ent.value = this.projectIdList[0].name;
              this.query.projectId = this.projectIdList[0].id;
              this.form.projectId = this.projectIdList[0].id;
              this.firstDisplayFlag = false;
            }
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            // this.selectionClear();
            this.initData(this.form.projectId);
            this.selectionKnowledgeClear();
          });
        }


    },
  },
};
</script>

<style>
</style>
